export const SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  AUTO: 'auto',
} as const;
